module.exports = __webpack_public_path__ + "media/images/promo/championship/digits/3-2a1ba1cfb99f4314dabfc257c2db83b7.png";